import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AddOnTooltips } from 'src/app/shared/models/app-models/ItemAddOn.model';
import { AddOn } from 'src/app/shared/models/database-models';

@Component({
  selector: 'app-add-on-form',
  templateUrl: './add-on-form.component.html',
  styleUrls: ['./add-on-form.component.scss'],
})
export class AddOnFormComponent implements OnChanges {
  @Input() isReadOnly: boolean = false;
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() data!: AddOn;
  @Input() priceQuantity: number = 0;
  @Output() formData = new EventEmitter();
  toggle: boolean = false;
  quantity: string = '';
  years: string = '0';
  months: string = '0';
  addOnTooltips = AddOnTooltips
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].currentValue) {
      const valueChange = changes['data'].currentValue;
      if (
        valueChange.isDeleted !== !this.toggle ||
        valueChange.Quantity !== this.quantity ||
        valueChange.DurationYears !== this.years ||
        valueChange.DurationMonths !== this.months
      ) {
        this.toggle =
          valueChange.isDeleted !== null ? !valueChange.isDeleted : false;
        this.quantity = valueChange.Quantity;
        this.years = valueChange.DurationYears;
        this.months = valueChange.DurationMonths;
      }
    }
  }

  returnTooltipInformation(){
    return AddOnTooltips[this.name] as any as InnerHTML
  }

  onInputChange() {
    if (
      Number(this.quantity) > this.priceQuantity &&
      this.name !== 'OptionToPurchase'
    ) {
      this.quantity = this.priceQuantity.toString();
    }
    if(this.name == 'OptionToPurchase'){
      this.priceQuantity = Infinity;
    }
    if (Number(this.months) > 11){
      this.months = '11'
    }
    else {
      this.emitFormData();
    }
  }

  emitFormData() {
    const emitData: AddOn = {
      ...this.data,
      isDeleted: !this.toggle,
      DurationMonths: this.months ? Math.abs(Math.round(Number(this.months))) : 0,
      DurationYears: this.years ? Math.abs(Math.round(Number(this.years))) : 0,
      Quantity: this.quantity ? +this.quantity : null,
    };
    this.formData.emit(emitData);
  }
  restrictNegativeNumberInput(event: Event, decimalPlaces?: number): void {
    const inputElement = event.target as HTMLInputElement;
    const enteredValue = parseFloat(inputElement.value);
    const numberOfDecimals = enteredValue.toString().split('.')[1]?.length;
    if (!isNaN(enteredValue) && numberOfDecimals > (decimalPlaces ?? 2)) {
      inputElement.value = inputElement.valueAsNumber.toFixed(
        decimalPlaces ?? 2
      );
    }
    if (!isNaN(enteredValue) && enteredValue < 0) {
      inputElement.value = '0';
    }
    if (!isNaN(enteredValue) && enteredValue > 999999999) {
      inputElement.value = '0';
    }
  }
}
